import React from 'react'

const Metadata = ({title}) => {
  return (
    <title>{title}</title>
  )
}

export default Metadata